import { viewport } from './module/common/viewport';
viewport();
